import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import {
  erc20HolderListKey,
  erc20TransferListKey,
  tokenCardListKey,
  tokenDetailKey
} from '~/api/service/query-keys.const'
import {
  NexonNativeTokenInfoModel,
  TokenCardListModel,
  TokenDetailModel,
  TokenHolderListModel,
  TokenTransferListModel
} from '~/types/model/token.model'
import { IPagination } from '~/types/pagination.type'
import { INftType, ITokenType } from '~/types/token-type.type'

import type { NexonNativeTokenInfo } from '../repository'
import type { EvmErc20TransferListInfo } from '../repository/models/EvmErc20TransferListInfo'
import type { EvmTokenHolderListInfo } from '../repository/models/EvmTokenHolderListInfo'

export const tokenService = {
  useGetTokenCardList: () => {
    const getTokenCardList = async () => {
      const res = await explorerApi.tokenController.getTokenCardList({
        requestBody: {}
      })
      return new TokenCardListModel(res)
    }
    return useQuery([ ...tokenCardListKey ], getTokenCardList)
  },

  useGetTokenDetail: (address: string, tokenType: ITokenType | INftType, tokenId?: string) => {
    const getTokenDetail = async () => {
      const res = await explorerApi.tokenController.getTokenDetail({
        requestBody: {
          ca: address,
          tokenType,
          tokenId: tokenId
        }
      })
      return new TokenDetailModel(res as EvmTokenDetailInfo)
    }
    return useQuery([ ...tokenDetailKey, address, tokenId ], getTokenDetail)
  },

  useGetNativeTokenDetail: () => {
    const getTokenDetail = async () => {
      const res = await explorerApi.nexon.getNativeToken({
        requestBody: {}
      })
      return new NexonNativeTokenInfoModel(res as NexonNativeTokenInfo)
    }

    return useQuery([ ...tokenDetailKey ], getTokenDetail)
  },

  useGetTokenTransferList: (pagination: Ref<IPagination>, address?: string) => {
    const getTokenTransferList = async () => {
      const res = await explorerApi.tokenController.getErc20TokenTransferList({
        requestBody: {
          ca: address,
          page: pagination.value.page,
          size: pagination.value.rowPerPage
        }
      })
      return new TokenTransferListModel(res as EvmErc20TransferListInfo)
    }
    return useQuery([ ...erc20TransferListKey, pagination, address ], getTokenTransferList)
  },

  useGetTokenHolderList: (pagination: Ref<IPagination>, address: string) => {
    const getTokenHolderList = async () => {
      const res = await explorerApi.tokenController.getErc20TokenHolderList({
        requestBody: {
          ca: address,
          page: pagination.value.page,
          size: pagination.value.rowPerPage
        }
      })
      return new TokenHolderListModel(res as EvmTokenHolderListInfo)
    }

    return useQuery([ ...erc20HolderListKey, address, pagination ], getTokenHolderList)
  }
}